import React, { useMemo } from 'react';
import { useAppSelector } from 'flow/hooks/useRedux';
import { TicketKey } from 'flow/types/EntityKeys';

import { getContactNameOrCompanyName } from 'flow/utils/contact-utils';
import PhoneNumber from 'flow/components/ui-components/PhoneNumber';
import {
    selectEventDTOSubtype,
    selectEventSender,
} from 'flow/selectors/TicketEventSelectors';
import { ConversationMessageKey } from 'flow/types/TicketEventData';
import { makeSelectContactDataForNumber } from 'flow/selectors/contact-selectors';
import { selectOriginDTOSubtype } from 'flow/selectors/TicketsSelectors';
import { originContactIsPhoneNumber } from 'flow/utils/ticket-channel-utils';

interface Props {
    ticketKey: TicketKey;
    messageKey: ConversationMessageKey;
}

const SenderExternal = ({ ticketKey, messageKey }: Props) => {
    const sender = useAppSelector((state) =>
        selectEventSender(state, ticketKey, messageKey),
    );

    const attachmentDtoSubtype = useAppSelector((state) =>
        selectEventDTOSubtype(state, ticketKey, messageKey),
    );

    const originSubtype = useAppSelector((state) =>
        selectOriginDTOSubtype(state, ticketKey),
    );

    if (attachmentDtoSubtype === 'OmniEmailMessageTicketEvent') {
        return <SenderExternalEmail sender={sender} />;
    }
    // A channel this client does not know may name its sender by a handle.
    if (!originContactIsPhoneNumber(originSubtype)) {
        return <span>{sender}</span>;
    }
    return <SenderExternalPhoneNumber sender={sender} />;
};

export default SenderExternal;

interface PropsSender {
    sender: string;
}

const SenderExternalEmail = ({ sender }: PropsSender) => {
    return <span>{sender}</span>;
    // Starting off with sender email only as to not risk showing a different contact than
    // the contact displayed in the left pane and right pane, where we display visitorContact,
    // in the event there are multiple contacts saved with the same email address.
    /*
    const selectContactData = useMemo(makeSelectContactDataForEmail, []);
    const contact = useAppSelector((state) => selectContactData(state, sender));

    return (
        <span>
            {getContactNameOrCompanyName(contact) || <span>{sender}</span>}
        </span>
    );
    */
};
SenderExternalEmail.displayName = 'SenderExternalEmail';

const SenderExternalPhoneNumber = ({ sender }: PropsSender) => {
    const selectContactData = useMemo(makeSelectContactDataForNumber, []);
    const contact = useAppSelector((state) => selectContactData(state, sender));

    return (
        <span>
            {getContactNameOrCompanyName(contact) || (
                <PhoneNumber number={sender} />
            )}
        </span>
    );
};
SenderExternalPhoneNumber.displayName = 'SenderExternalPhoneNumber';
